import loadable from '@loadable/component';

export const NewbuildingPromoCarouselContainerLoadable = loadable(() => import('./NewbuildingPromoCarousel'));
